import React from 'react';
import QuestionLabel from './QuestionLabel';

const TextQuestion = ({ label, value, setValue, settings }) => {
    const type = settings?.numeric ? 'number' : 'text';

    return (
        <label>
            <QuestionLabel label={label} settings={settings} />
            <div>
                <input
                    type={type}
                    min={settings?.min}
                    max={settings?.max}
                    value={value || ''}
                    onChange={e => setValue(e.target.value)}
                />
            </div>
        </label>
    );
};

export default TextQuestion;
